const AIRTABLE_TOKEN = "patSHzPfBa4YVysWX.c2aae957983d094b53dd12e1bc29e290fd31bfdd2624c5c9dba3202d49f90943";
const AIRTABLE_BASE_ID = "app6SwrALupL1F6KR";
const AIRTABLE_TABLE_NAME = "tblOGyy7swiqXkIOZ";

const airtableHeaders = {
  Authorization: `Bearer ${AIRTABLE_TOKEN}`,
  "Content-Type": "application/json",
};

export async function saveRecipeToAirtable(recipe) {
  const url = `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_TABLE_NAME}`;
  const body = {
    fields: {
      Name: recipe.title,
      Ingredients: JSON.stringify(recipe.ingredients),
    },
  };
  const res = await fetch(url, {
    method: "POST",
    headers: airtableHeaders,
    body: JSON.stringify(body),
  });
  let json;
  try {
    json = await res.json();
  } catch (e) {
    json = { error: 'Invalid JSON response', status: res.status };
  }
  if (!res.ok) {
    console.error('Airtable API error:', res.status, json);
    if (json && json.error) {
      console.error('Airtable error details:', json.error);
      alert('Airtable error: ' + (json.error.message || JSON.stringify(json.error)));
    }
  }
  return json;
}

export async function updateRecipeInAirtable(recipe) {
  if (!recipe.id) return;
  const url = `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_TABLE_NAME}/${recipe.id}`;
  const body = {
    fields: {
      Name: recipe.title,
      Ingredients: JSON.stringify(recipe.ingredients),
    },
  };
  const res = await fetch(url, {
    method: "PATCH",
    headers: airtableHeaders,
    body: JSON.stringify(body),
  });
  return res.json();
}

export async function deleteRecipeFromAirtable(recipeId) {
  if (!recipeId) return;
  const url = `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_TABLE_NAME}/${recipeId}`;
  await fetch(url, {
    method: "DELETE",
    headers: airtableHeaders,
  });
}

export async function loadRecipesFromAirtable() {
  const url = `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_TABLE_NAME}`;
  const res = await fetch(url, {
    headers: airtableHeaders,
  });
  const data = await res.json();
  return (data.records || []).map((rec) => ({
    id: rec.id,
    title: rec.fields.Name,
    ingredients: JSON.parse(rec.fields.Ingredients || "[]"),
  }));
}
